import styles from "./Footer.module.scss";

import facebookWhite from "../../assets/images/facebook_white.svg";
import xWhite from "../../assets/images/x_white.svg";
import rssWhite from "../../assets/images/rss_white.svg";

import pragueLogo from "../../assets/images/prague_logo.svg";
import tskLogo from "../../assets/images/tsk_logo.svg";
import { useTranslation } from "react-i18next";

type Props = {};

const Footer = ({ ...props }: Props) => {
    const date = new Date();
    const { t } = useTranslation();

    return (
        <div className={styles.footer}>
            <div className={styles.leftSide}>
                <div className={styles.links}>
                    <a className={styles.link} target={"_blank"} href={"https://parking.praha.eu/cs/moznosti-parkovani-v-praze/"}>
                        {t("global.pageUrl")}
                    </a>
                    <a className={styles.link} href={"/gdpr"}>
                        {t("gdpr.title")}
                    </a>
                    <a className={styles.link} href={"/cookies"}>
                        {t("cookies.title")}
                    </a>
                    <a className={styles.link} href={"/legal-information"}>
                        {t("legalInformation.title")}
                    </a>
                </div>
                <div className={styles.bottomText}>{t("footer.content")}</div>
            </div>
            <div className={styles.rightSide}>
                <div className={styles.followContainer}>
                    <span>{t("footer.follow")}</span>
                    <a className={styles.followLink} target={"_blank"} href={"https://www.facebook.com/TSKPraha/"}>
                        <img src={facebookWhite} />
                    </a>
                    <a className={styles.followLink} target={"_blank"} href={"https://x.com/tskpraha"}>
                        <img src={xWhite} />
                    </a>
                    <a className={styles.followLink} target={"_blank"} href={"https://parking.praha.eu/cs/feed/"}>
                        <img src={rssWhite} />
                    </a>
                </div>
                <div className={styles.logos}>
                    <a className={styles.logoLink} target={"_blank"} href={"https://praha.eu"}>
                        <img src={pragueLogo} />
                    </a>
                    <a className={styles.logoLink} target={"_blank"} href={"https://www.tsk-praha.cz"}>
                        <img src={tskLogo} />
                    </a>
                </div>
                <div className={`${styles.copyright}`}>&copy;&nbsp;{date.getFullYear()}</div>
            </div>
        </div>
    );
};

export default Footer;
